import { ActorFilterByType } from './categories/ActorFilterByType';
import { ActorFilterGlobal } from './categories/ActorFilterGlobal';
import { ActorFilterMultipleChoice } from './categories/ActorFilterMultipleChoice';
import { ActorFilterQuestion } from './categories/ActorFilterQuestion';
import { ActorFilterItem } from './categories/ActorFilterItem';
import { RegistryRoof } from '../RegistryRoof';
import { ActorFilterKnowAWord } from './categories/ActorFilterKnowAWord';
import { ActorFilterTag } from './categories/ActorFilterTag';
export class ActorFilterRegistry extends RegistryRoof {
    registryType = 'actorfilter';
    c_tag = new ActorFilterTag(this);
    c_global = new ActorFilterGlobal(this);
    c_byActorType = new ActorFilterByType(this);
    c_mc = new ActorFilterMultipleChoice(this);
    c_kaw = new ActorFilterKnowAWord(this);
    c_item = new ActorFilterItem(this);
    c_q = new ActorFilterQuestion(this);
    get registry_object() {
        return super.registry_object;
    }
}
